import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { DoorStrip } from './DoorStrip';
type FooterProps = {
  onNavigate?: (page: string) => void;
};
export function Footer({
  onNavigate
}: FooterProps) {
  const nav = (page: string) => onNavigate?.(page);
  return <footer className="w-full bg-black text-white" data-id="element-118">
      <DoorStrip height="h-4" data-id="element-119" />
      <div className="py-16 px-6" data-id="element-120">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-121">
          <div data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/ewfDCj5QKNDNeQRsTcwjBG/logo_de_Junquito_Gas_(4).ai_(4).png" alt="La Cochera" className="h-12 w-auto mb-6 opacity-90" data-id="element-123" />
            <p className="text-stone-400 text-sm leading-relaxed" data-id="element-124">
              Cocina auténtica con ingredientes locales. Pasión por el sabor en
              cada plato.
            </p>
          </div>

          <div data-id="element-125">
            <h4 className="text-xs font-extrabold tracking-widest uppercase text-white mb-6 font-display" data-id="element-126">
              Navegación
            </h4>
            <ul className="space-y-4 text-sm text-stone-400 font-medium" data-id="element-127">
              {[['Inicio', 'home'], ['Menú', 'menu'], ['Pedir', 'order'], ['Reservas', 'reservas']].map(([name, page]) => <li key={page} data-id="element-128">
                  <button onClick={() => nav(page)} className="hover:text-white transition-colors" data-id="element-129">
                    {name}
                  </button>
                </li>)}
            </ul>
          </div>

          <div data-id="element-130">
            <h4 className="text-xs font-extrabold tracking-widest uppercase text-white mb-6 font-display" data-id="element-131">
              Horario
            </h4>
            <div className="space-y-4 text-sm text-stone-400" data-id="element-132">
              <div data-id="element-133">
                <p className="text-white font-bold mb-1" data-id="element-134">Lunes — Viernes</p>
                <p data-id="element-135">10:00 AM – 11:00 PM</p>
              </div>
              <div data-id="element-136">
                <p className="text-white font-bold mb-1" data-id="element-137">Sábado — Domingo</p>
                <p data-id="element-138">10:00 AM – 11:00 PM</p>
              </div>
            </div>
          </div>

          <div data-id="element-139">
            <h4 className="text-xs font-extrabold tracking-widest uppercase text-white mb-6 font-display" data-id="element-140">
              Contacto
            </h4>
            <ul className="space-y-4 text-sm text-stone-400" data-id="element-141">
              <li className="flex items-start gap-3" data-id="element-142">
                <MapPinIcon className="w-4 h-4 text-stone-500 mt-0.5 flex-shrink-0" data-id="element-143" />
                Santiago, RD
              </li>
              <li className="flex items-center gap-3" data-id="element-144">
                <PhoneIcon className="w-4 h-4 text-stone-500 flex-shrink-0" data-id="element-145" />
                +1 (809) 247-7373
              </li>
              <li className="flex items-center gap-3" data-id="element-146">
                <MailIcon className="w-4 h-4 text-stone-500 flex-shrink-0" data-id="element-147" />
                info@lacochera.com
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-stone-900 text-center text-xs text-stone-600 font-medium tracking-wide" data-id="element-148">
          © 2025 La Cochera. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}